export enum SelectedLink {
    EMPTY = '',
    PERSONAL_INFO = 'PERSONAL_INFO',
    PROFILS = 'PROFILS',
    DOCUMENTS = 'DOCUMENTS',
    TRACKINGDELIVERY = 'TRACKINGDELIVERY',
    CONTACT = 'CONTACT',
    AVANTAGES_CLIENT = 'AVANTAGES_CLIENT',
    ORANGE_SERVICES = 'ORANGE_SERVICES',
    FACTURES = 'FACTURES',
    OFFRE_OPTIONS = 'OFFRE_OPTIONS',
    CYBERSECURITY = 'CYBERSECURITY',
    tv = 'tv',
    livebox = 'livebox',
    mobile = 'mobile',
    airbox = 'airbox',
    sim = 'sim',
    multiSimI = 'multiSimI',
    multiSimIA = 'multiSimIA',
    flybox = 'flybox',
    smartWatch = 'smartWatch',
    landline = 'landline',
    voip = 'voip',
}

export interface NavDisplayConfig {
    lateralMenu: boolean;
    carrousel: boolean;
    selectedLink: SelectedLink;
}
